const isNotNull = (data) => {
  let value = data.value;
  if (value === null || value === undefined) return "this field is required"
  value = value.trim();
  return (value === "" || value === null) ? "this field is required" : true;
}

export default isNotNull;
